<template>
<a-modal v-model:visible="log.islog" @cancel="cancel" style="min-width: 1300px" :footer="null">
    <a-pagination 
    @show-size-change="setlimit"
    @change="set_logpage"
    show-size-changer 
    show-quick-jumper 
    v-model:current="logpage" 
    v-model:page-size="loglimit" 
    :page-size-options="['10','30','50']" 
    :total="logtotal"
    :show-total="total=>'共有'+logtotal+'条日志'"
    style="margin:20px;"
    >
    </a-pagination>
    <a-table 
      :data-source="loglist"
      row-key="logId"
      :pagination="false"
    :scroll="{y: 560 }"
      >
        <a-table-column
        key="logId"
        title="日志ID"
        data-index="logId"
        align="center"
      />
      <a-table-column
        key="beanName"
        title="bean名称"
        data-index="beanName"
        align="center"
      />
      <a-table-column
        key="params"
        title="参数"
        data-index="params"
        align="center"
      />
      <a-table-column
        key="status"
        title="状态"
        align="center"
      >
      <template v-slot="scope">
        <span>
          <a-tag v-if="scope.text.status==0" color="success">正常</a-tag>
          <a-tag v-if="scope.text.status==1" color="error">停用</a-tag>
        </span>
      </template>
      </a-table-column>
      <a-table-column
        key="error"
        title="报错"
        align="center"
        :ellipsis="true"
      >
      <template v-slot="scope">
          <span :title="scope.text.error">
              {{scope.text.error? scope.text.error : 'null'}}
          </span>
      </template>
      </a-table-column>
      <a-table-column
        key="times"
        title="操作次数"
        data-index="times"
        align="center"
      />
      <a-table-column
        key="createTime"
        title="创建时间"
        data-index="createTime"
        align="center"
      />
    </a-table>
    
</a-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: '',
  props: {
      log:{
          islog:true
      }
  },
  data() {
    return {
    };
  },
  created(){
      this.QueryScheduleLog()
  },
  computed: {
      ...mapGetters({
          loglist:"schedule/loglist",
          logpage:"schedule/logpage",
          loglimit:"schedule/loglimit",
          logtotal:"schedule/logtotal"
      })
  },
  watch: {},
  methods: {
      ...mapActions({
        QueryScheduleLog:"schedule/QueryScheduleLog",
        set_logpage:"schedule/set_logpage",
        set_loglimit:"schedule/set_loglimit",
      }),
      cancel(){
          this.log.islog = false
      },
      setlimit(data1,data2){
      this.set_loglimit({data1,data2})
    },
  },
  components: {},
  filters: {}
};
</script>
<style lang='scss' scoped>
</style>